import { Stack } from '@mui/material';
import TextFieldWithMessage from '@/views/auth/comopnents/TextFieldWithMessage';

const LoginInputs = ({ onChangeIdInput, onChangePwInput }: { onChangeIdInput: (e: InputEvent) => void; onChangePwInput: (e: InputEvent) => void }) => {
  return (
    <Stack gap="20px">
      <TextFieldWithMessage placeholder="아이디를 입력하세요" onChange={onChangeIdInput} showMessage={false} />
      <TextFieldWithMessage placeholder="비밀번호를 입력하세요" onChange={onChangePwInput} showMessage={false} isBlurData={true} />
    </Stack>
  );
};

export default LoginInputs;
